﻿'use strict';
import Axios from 'axios';
import { TweenLite, CSSPlugin, ScrollToPlugin } from "gsap/all";
const plugins = [CSSPlugin, ScrollToPlugin];


export default class WaitlistModal {

    constructor() {

        if (!d.querySelector("#waitlistModal")) {
            return;
        }

        const HideRegModal = () => {
            TweenLite.to(d.querySelector("#waitlistModal"), .5, {
                alpha: 0,
                onComplete: () => {
                    d.querySelector("body").classList.remove("modal-open");
                    d.querySelector("#waitlistModal").style.display = "";
                }
            });
            if (window.hasOwnProperty("gtag")) {
                gtag('event', 'pyc_waitlist_modal_hide', {
                    'modal_name': d.querySelector(".innerModal .header").innerText
                });
            }
        }
        const ShowRegModal = () => {

            if (!window.grecaptcha) {
                var sc = document.createElement("script");
                sc.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=6LdDWSQkAAAAAJ29aJlFYvPyIx1xRkmmd8P4kmoq");
                d.querySelector("#waitlistModal").appendChild(sc);

                //https://www.google.com/recaptcha/api.js?render=6LdDWSQkAAAAAJ29aJlFYvPyIx1xRkmmd8P4kmoq
            }


            d.querySelector("#waitlistModal").style.display = "block";
            TweenLite.set(d.querySelector("#waitlistModal"), { opacity: 0 });
            TweenLite.to(d.querySelector("#waitlistModal"), .5, {
                opacity: 1, onComplete: () => {
                    d.querySelector("body").classList.add("modal-open");

                    d.querySelector("#WaitlistName").value = "";
                    d.querySelector("#WaitlistName").classList.remove("error");

                    d.querySelector("#WaitlistEmail").value = "";
                    d.querySelector("#WaitlistEmail").classList.remove("error");

                    d.querySelector("#WaitlistLastName").value = "";
                    d.querySelector("#WaitlistLastName").classList.remove("error");

                    d.querySelector(".agreeContainer").classList.remove("error");
                    d.querySelector(".agreeContainer input").checked = false;

                    d.querySelector("#WaitlistClassBtn").classList.remove("disabled");



                }
            });
        }


        this.OpenWaitlistModal = (orgId, classId, element) => {

            d.querySelector("#WaitlistClassId").value = classId;
            d.querySelector("#WaitlistOrganizationId").value = orgId;


            var image = element.querySelector("picture").outerHTML;
            var bottomText = element.querySelector(".card-bottom").innerHTML;
            d.querySelector("#waitlistModal .innerModal__top").innerHTML = image;


            d.querySelector("#waitlistModal .dynamic").innerHTML = bottomText;

            if (d.querySelector("#waitlistModal .dynamic .more_info")) {
                d.querySelector("#waitlistModal .dynamic .more_info").remove();
            }

            d.querySelector("#waitlistModal .agreeContainer").style.display = "";

            d.querySelectorAll("#waitlistModal .formItem").forEach((item) => {
                item.style.display = "";
            });
            
            d.querySelectorAll("#waitlistModal .resultItem").forEach((item) => {
                item.style.display = "none";
            });

            if (window.hasOwnProperty("gtag")) {
                gtag('event', 'modal_waitlist_open', {
                    'modal_name': d.querySelector(".innerModal .header").innerText
                });
            }
            ShowRegModal();
        }

        d.querySelector("#WaitlistClassBtn").addEventListener("click", (e) => {
            var classId = parseInt(d.querySelector("#WaitlistClassId").value);
            var orgId = parseInt(d.querySelector("#WaitlistOrganizationId").value);
            var name = d.querySelector("#WaitlistName").value;
            var lastName = d.querySelector("#WaitlistLastName").value;
            var email = d.querySelector("#WaitlistEmail").value;
            var agreeCheck = d.querySelector("#WaitlistAgreeCheck").checked;

            e.currentTarget.classList.add("disabled");
            d.querySelector("#WaitlistErrors").innerHTML = "";
            d.querySelector("#WaitlistErrors").style.display = "";
            var isValid = true;

            if (!name) {
                isValid = false;
                d.querySelector("#WaitlistName").classList.add("error");
            }
            
            if (!lastName) {
                isValid = false;
                d.querySelector("#WaitlistLastName").classList.add("error");
            }

            if (!email || !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
                isValid = false;
                d.querySelector("#WaitlistEmail").classList.add("error");
            }


            if (isValid) {
                if (window.hasOwnProperty("gtag")) {
                    gtag('event', 'pyc_modal_waitlist', {
                        'modal_name': d.querySelector(".innerModal .header").innerText
                    });
                }
                grecaptcha.ready(function () {
                    grecaptcha.execute('6LdDWSQkAAAAAJ29aJlFYvPyIx1xRkmmd8P4kmoq', { action: 'submit' }).then(function (token) {
                        

                        Axios.post("/api/pyc/WaitlistClass", {
                            "ClassId": classId,
                            "OrganizationId": orgId,
                            "Name": name,
                            "LastName": lastName,
                            "Email": email,
                            "OptIn": agreeCheck,
                            "recaptcharesponse": token
                        }).then((result) => {

                            var errors = result.data;

                            if (errors.length > 0) {
                                d.querySelector("#RegisterClassBtn").classList.remove("disabled");

                                var errorDivs = "";
                                errors.forEach((item) => {
                                    errorDivs += `<div class="error">${item}</div>`;
                                });
                                d.querySelector("#WaitlistErrors").innerHTML = errorDivs;
                                d.querySelector("#WaitlistErrors").style.display = "block";

                                TweenLite.delayedCall(5, () => {
                                    d.querySelector("#WaitlistErrors").style.display = "none";
                                    d.querySelector("#WaitlistErrors").innerHTML = "";
                                });


                            } else {

                                d.querySelector("#waitlistModal .header").innerText = "You're on the Waitlist for " + d.querySelector("#waitlistModal .header").innerText;

                                d.querySelector("#waitlistModal .waitlist-warning").style.display = "none";
                                d.querySelector("#waitlistModal .agreeContainer").style.display = "none";

                                d.querySelectorAll("#waitlistModal .formItem").forEach((item) => {
                                    item.style.display = "none";
                                });

                                d.querySelectorAll("#waitlistModal .resultItem").forEach((item) => {
                                    item.style.display = "";
                                });

                            }
                        });

                    });
                });


            } else {
                e.currentTarget.classList.remove("disabled");
            }
            
        });


        d.querySelector("#WaitlistName").addEventListener("blur", (e) => {
            if (d.querySelector("#WaitlistName").classList.contains("error")) {
                if (d.querySelector("#WaitlistName").value) {
                    d.querySelector("#WaitlistName").classList.remove("error");
                }
            }
        });
        d.querySelector("#WaitlistLastName").addEventListener("blur", (e) => {
            if (d.querySelector("#WaitlistLastName").classList.contains("error")) {
                if (d.querySelector("#WaitlistLastName").value) {
                    d.querySelector("#WaitlistLastName").classList.remove("error");
                }
            }
        });
        d.querySelector("#WaitlistEmail").addEventListener("blur", (e) => {
            if (d.querySelector("#WaitlistEmail").classList.contains("error")) {
                var email = d.querySelector("#WaitlistEmail").value;
                if (email && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
                    d.querySelector("#WaitlistEmail").classList.remove("error");
                }
            }
        });


        d.querySelector("#waitlistModal .curtain").addEventListener("click", (e) => {
            HideRegModal();
        });

    }
}